var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcToiletBoth = function SvgIcToiletBoth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#67AEFF",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M13.803 12.846a2.08 2.08 0 0 0-1.729-.912H5.54c-.704 0-1.336.334-1.73.912a2.06 2.06 0 0 0-.226 1.944l3.22 8.377a.4.4 0 0 1 .023.137v4.293c0 1.091.889 1.98 1.98 1.98s1.98-.889 1.98-1.98v-4.293a.4.4 0 0 1 .023-.137l3.22-8.377a2.09 2.09 0 0 0-.227-1.944ZM8.802 10.06a3.146 3.146 0 1 0 0-6.293 3.146 3.146 0 0 0 0 6.292Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6363",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "m29.033 21.386-1.871-7.315c-.154-.602-.547-1.145-1.114-1.532a3.55 3.55 0 0 0-1.998-.602h-3.02c-.723 0-1.438.214-1.998.602-.561.387-.96.93-1.115 1.532l-1.871 7.315c-.084.34.007.691.266.96.26.267.638.428 1.052.428h1.479c.21 0 .392.126.434.299l1.36 5.204c.203.763.981 1.3 1.906 1.3s1.703-.537 1.907-1.3l1.36-5.204c.041-.173.224-.299.434-.299h1.479c.406 0 .792-.155 1.05-.429a.99.99 0 0 0 .267-.96zM22.545 10.06a3.147 3.147 0 1 0 0-6.294 3.147 3.147 0 0 0 0 6.294Z"
  })));
};
export default SvgIcToiletBoth;